// @flow
import { CommonActions } from '@react-navigation/native';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import CreateAccount from './CreateAccount';
import ValidationService from '../../../lib/validation';
import { createAccountFormValuesSelector } from '../../../modules/SignUp/Login/reducer';
import { triggerEmailValidationDuringActivate } from '../../../modules/SignUp/actions';
import { isLoadingSelector } from '../../../modules/LoadingStatus/reducer';

import type { DispatchProps, StateProps } from './CreateAccount';
import type { StateType } from '../../../modules/reducers';
import Navigation from '../../../lib/navigation';

const validate = values => ({
  email: ValidationService.validateEmail(values.email),
  password: ValidationService.validatePassword(values.password),
});

const mapStateToProps = (state: StateType): StateProps => ({
  initialValues: createAccountFormValuesSelector(state),
  isLoading: isLoadingSelector(state, 'createAccountDuringActivate'),
  showAlreadyHaveAccount: true,
});

const mapDispatchToProps: DispatchProps = {
  onSubmit: triggerEmailValidationDuringActivate,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    goToLoginPage: () => Navigation.dispatch(CommonActions.goBack()),
  }),
  reduxForm({ form: 'createAccountDuringActivate', validate })
);

export default enhance(CreateAccount);
